import { useState } from "react"
import { useLocalization } from "@fluent/react"
import LightModeIcon from "@mui/icons-material/LightMode"
import PaletteIcon from "@mui/icons-material/Palette"
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined"
import WaterIcon from "@mui/icons-material/Water"
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material"

export type OverviewColorMode = "light" | "plum" | "ocean"

type OverviewColorModeMenuProps = {
    value: OverviewColorMode
    onChange: (mode: OverviewColorMode) => void
}

export const OverviewColorModeMenu = ({ value, onChange }: OverviewColorModeMenuProps) => {
    const { l10n } = useLocalization()
    const oceanLabel = l10n.getString("operational-dashboard-color-ocean", null, "_Morski")
    const lightLabel = l10n.getString("operational-dashboard-color-light", null, "_Jasny")
    const plumLabel = l10n.getString("operational-dashboard-color-plum", null, "_Śliwkowy")
    const modeLabel = l10n.getString("operational-dashboard-color-mode", null, "_Motyw dashboardu")
    const [anchor, setAnchor] = useState<HTMLElement | null>(null)
    const selectMode = (mode: OverviewColorMode) => {
        onChange(mode)
        setAnchor(null)
    }

    return (
        <>
            <Tooltip title={modeLabel}>
                <IconButton aria-label={modeLabel} aria-haspopup="menu"
                    aria-controls={anchor ? "operational-dashboard-color-menu" : undefined}
                    aria-expanded={Boolean(anchor)}
                    onClick={event => setAnchor(event.currentTarget)}
                    sx={{ alignSelf: "center", color: "primary.main" }}>
                    <PaletteOutlinedIcon />
                </IconButton>
            </Tooltip>
            <Menu id="operational-dashboard-color-menu" anchorEl={anchor} open={Boolean(anchor)}
                onClose={() => setAnchor(null)} MenuListProps={{ "aria-label": modeLabel }}>
                <MenuItem selected={value === "ocean"} onClick={() => selectMode("ocean")}>
                    <ListItemIcon><WaterIcon fontSize="small" sx={{ color: "#147B82" }} /></ListItemIcon>
                    <ListItemText>{oceanLabel}</ListItemText>
                </MenuItem>
                <MenuItem selected={value === "light"} onClick={() => selectMode("light")}>
                    <ListItemIcon><LightModeIcon fontSize="small" sx={{ color: "#526775" }} /></ListItemIcon>
                    <ListItemText>{lightLabel}</ListItemText>
                </MenuItem>
                <MenuItem selected={value === "plum"} onClick={() => selectMode("plum")}>
                    <ListItemIcon><PaletteIcon fontSize="small" sx={{ color: "#6253B8" }} /></ListItemIcon>
                    <ListItemText>{plumLabel}</ListItemText>
                </MenuItem>
            </Menu>
        </>
    )
}
